window.IlmasPdp = window.IlmasPdp || {};
(function (api) {
  function pushPair(pairs, label, value) {
    if (!label || !value) return;
    if (api.isZeroish(value) && !/[a-zA-ZáéíóúÁÉÍÓÚ%]/.test(value)) return;
    var key = label.toUpperCase();
    if (pairs.some(function (p) { return p.label.toUpperCase() === key; })) return;
    pairs.push({ label: label, value: value });
  }

  function fromAttribute(li) {
    var labelEl = li.querySelector('.label, label');
    var label = api.textOf(labelEl).replace(/:\s*$/, '');
    var value = '';
    li.querySelectorAll('span').forEach(function (sp) {
      if (sp === labelEl || (labelEl && labelEl.contains(sp))) return;
      var tv = api.textOf(sp);
      if (tv) value = value ? value + ' ' + tv : tv;
    });
    if (!value) {
      var clone = li.cloneNode(true);
      var lab = clone.querySelector('.label, label');
      if (lab) lab.remove();
      value = api.textOf(clone);
    }
    return { label: label, value: value };
  }

  function fromColonList(src, pairs) {
    src.querySelectorAll('li').forEach(function (li) {
      var m = api.textOf(li).match(/^([^:]{2,48}):\s*(.{1,80})$/);
      if (m) pushPair(pairs, m[1].trim(), m[2].trim());
    });
  }

  function fromStrongDivs(src, pairs) {
    src.querySelectorAll('div').forEach(function (div) {
      if (div.querySelector('div, ul, .attribute-values')) return;
      var strong = div.querySelector(':scope > strong, :scope > div > strong');
      if (!strong) return;
      var label = api.textOf(strong).replace(/:\s*$/, '');
      if (!label || label.length > 60) return;
      var clone = div.cloneNode(true);
      clone.querySelectorAll('strong').forEach(function (s) { s.remove(); });
      var value = api.textOf(clone);
      if (value && value.length <= 80) pushPair(pairs, label, value);
    });
  }

  api.attrPairs = function (src) {
    var pairs = [];
    src.querySelectorAll('.attribute-values').forEach(function (li) {
      var row = fromAttribute(li);
      pushPair(pairs, row.label, row.value);
    });
    if (!pairs.length) fromColonList(src, pairs);
    fromStrongDivs(src, pairs);
    return pairs;
  };
})(window.IlmasPdp);
